import React, { Component } from "react";
import { scoreValidation } from "../../assets/Js/scoreValidation";
import style from "./AddScore.module.css";

export default class CustomRep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input1: "",
      input2: "",
    };
  }

  componentDidMount() {
    if (this.props.editable) {
      this.setNewState();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editable !== this.props.editable) {
      this.setNewState();
    }
  }

  setNewState() {
    if (this.props.values) {
      let newField =
        this.props.values && this.props.values.split(this.props.seperateSign);
      this.setState({
        input1: newField[0] ? newField[0] : "",
        input2: newField[1] ? newField[1] : "",
      });
    }
    else{
      this.setState({
        input1:'',
        input2:'',
      })
    }
  }

  handleChangeValue1(value) {
    let strVal = value.toString();
    if (strVal === "") {
      strVal = "0";
    }
    if (scoreValidation(strVal)) {
      this.setState({
        input1: strVal,
      });
      let secondInput = this.state.input2 ? this.state.input2 : "0";
      this.props.handleChange(
        strVal + this.props.seperateSign + secondInput,
        this.props.index
      );
      return;
    } else {
      this.resetInputValues();
      //   showToastMessage('error', 'top', 'Not a valid score', 3000, 50);
    }
  }

  handleChangeValue2(value) {
    let strVal = value.toString();
    if (strVal === "") {
      strVal = "0";
    }
    if (scoreValidation(strVal)) {
      this.setState({
        input2: strVal,
      });
      let firstInput = this.state.input1 ? this.state.input1 : "0";
      this.props.handleChange(
        firstInput + this.props.seperateSign + strVal,
        this.props.index
      );
      return;
    } else {
      this.resetInputValues();
    }
  }

  resetInputValues() {
    if (this.props.values) {
      let newField = this.props.values.split(this.props.seperateSign);
      this.setState({
        input1: newField[0],
        input2: newField[1],
      });
    }
  }
  
  render() {
    return (
      <div className="d-flex align-items-center">
        <div className={`${style.flex2}`}>
          <input
            type="number"
            min="0"
            value={this.state.input1 || ""}
            className={`form-control mt-2 rounded ${style.scoreTypeInput} colorWhtie textAlignCenter`}
            // ref={this.scoreArrayRef}
            onChange={(e) => this.handleChangeValue1(e.target.value)}
            placeholder={this.props.firstInputName}
          />
        </div>
        <div className="ml-2 mr-2">
          <span className="font-weight-bold ">+</span>
        </div>
        <div className={`${style.flex2}`}>
          <input
            type="number"
            min="0"
            value={this.state.input2 || ""}
            className={`form-control mt-2 rounded ${style.scoreTypeInput} colorWhtie textAlignCenter`}
            // ref={this.scoreArrayRef}
            onChange={(e) => this.handleChangeValue2(e.target.value)}
            placeholder={this.props.secondInputName}
          />
        </div>
      </div>
    );
  }
}
